import React from 'react';
import { Layout, } from 'antd';
import { RouteComponentProps } from 'react-router';
import LayoutBase from './LayoutBase'
const { Content, Header, Footer } = Layout;


export default class extends React.PureComponent<RouteComponentProps<any> & { route: IRoute }> {
	render() {
		let { route } = this.props;
		let PageComponent = route.component
		return (
			<LayoutBase {...this.props}>
				<PageComponent {...this.props} />
			</LayoutBase>
		);
	}

}


// WEBPACK FOOTER //
// ./src/layouts/PublicLayout.tsx